import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import Page from '../shared/page';

import { currentUserRole } from '../../util';

class HomePage extends Component {
  render(){

    // console.log('rendering HOME page!');

    const name = this.props.user.firstName + ' ' + this.props.user.lastName;
    const organizationId = this.props.user.organizationId;

    const authenticated = this.props.authenticated;

    // console.log('authenticated: ', authenticated);

    //For now just redirect to "home" routes based on current user role
    let navigateTo = false;

    switch(currentUserRole()){
      case 'employee':
      default:
        navigateTo = '/sprint';
      break;
      case 'manager':
        navigateTo = '/teams';
      break;
      case 'salesleader':
        navigateTo = '/teams';
      break;
      case 'admin':
        navigateTo = '/people';
      break;
    }

    // console.log('navigateTo: ', navigateTo);

    return(
      <Page pageClass="home">
        {authenticated && navigateTo &&
          <Redirect to={navigateTo} />
        }
        {!navigateTo &&
          <h1>Home</h1>
        }
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(HomePage);



// WEBPACK FOOTER //
// ./src/components/home/index.js